import React from 'react';
import styles from './_style.module.scss';
import LoadingSpinner from '../../shared/LoadingSpinner';

const QuoteBuilderLayout = ({ drawing, loading, children }) => {
  return (
    <div className={styles.layoutContainer} data-widget-element="layout-container">
      {loading ? (
        <LoadingSpinner />
      ) : (
        <>
          <div className={styles.imageColumn} data-widget-element="image-column">
            {drawing.image !== undefined && (
              <img
                src={drawing.image.three_d_image_url}
                className={styles.previewImage}
                alt="3D Preview"
                data-widget-element="preview-image"
              />
            )}
          </div>
          <div className={styles.formColumn} data-widget-element="form-column">
            <div className={styles.header} data-widget-element="header">
              <h3 className={styles.title} data-widget-element="title">{t('quote_builder_widget.get_a_quote')}</h3>
              <hr className={styles.divider} data-widget-element="divider" />
            </div>
            <div data-widget-element="form-section">
              {children}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default QuoteBuilderLayout;
